/**
 * Dispatcher for in-app notification popups. Picks the visual variant
 * based on `notification.template`:
 *
 *   - 'showcase' → ShowcaseModal-styled popup (announcement / new model)
 *   - 'longform' → LongFormModal-styled popup (explanation / policy / guide)
 *   - 'simple'   → legacy slider popup (default for old records without
 *                   `template`; new broadcasts default to 'showcase')
 */

import type { InAppNotification } from '../../../types';
import Simple from './Simple';
import Showcase from './Showcase';
import LongForm from './LongForm';

interface NotificationPopupProps {
  notification: InAppNotification;
  onDismiss: () => void;
}

const NotificationPopup = ({ notification, onDismiss }: NotificationPopupProps) => {
  switch (notification.template) {
    case 'showcase':
      return <Showcase notification={notification} onDismiss={onDismiss} />;
    case 'longform':
      return <LongForm notification={notification} onDismiss={onDismiss} />;
    case 'simple':
    default:
      return <Simple notification={notification} onDismiss={onDismiss} />;
  }
};

export default NotificationPopup;
